export enum LocaleEnum {
  EN = 'EN',
  JPN = 'JPN',
}
